/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:relative}.camera-bar[_ngcontent-%COMP%]{background:#fff;border-radius:4px;box-shadow:0 1px 4px rgba(0,0,0,.3);display:flex;flex-direction:column}.camera-bar__divider[_ngcontent-%COMP%]{height:1px;width:100%;background:#eaeff5}"];
export { styles as styles };
